export const LoginTypes = {
    LOGIN_START: 'Login/LOGIN_START',
    LOGIN_FINISH: "Login/LOGIN_FINISH",
    LOGIN_CREATE_START: "Login/LOGIN_CREATE_START",
    LOGIN_CREATE_FINISH: "Login/LOGIN_CREATE_FINISH",
    LOGIN_MODAL_CLOSE: "LOGIN/LOGIN_MODAL_CLOSE",
    LOGOUT: "Login/LOGOUT"
};
